<template>
  <v-responsive :style="{ ...(isMobile ? { position: 'relative', zIndex: 1200 } : {position: 'relative', zIndex: 120}), opacity: 0.5 }">
    <v-footer app clipped-left float-left color="transparent" height="278px" width="7%" inset class="lighten-1 text-center">
      <v-card class="align-art flex-column" color="transparent">
        <!-- Beginning of dollar icon and dialog box -->
        <v-col cols="auto">
          <v-dialog persistent v-model="openFeedback" width="420"
            style="position: absolute; z-index: 1200;"
            max-height="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined small v-on="on" v-bind="attrs" fab class="ma-1 white-text" color="white">
                  <v-icon medium color="white" size="30">mdi-tooltip-question-outline</v-icon>
              </v-btn>
            </template>
            <v-card outlined>
              <v-form v-model="form" ref="form" v-on:submit.prevent="handleFeedbackUpload">
                <v-list-item three-line>
                <v-list-item-content>
                    <div class="text-overline mb-4">
                    Tell us, what you think improve Triyangle?
                    </div>
                    <v-textarea v-model="feedbackMessage" outlined filled auto-grow></v-textarea>
                </v-list-item-content>
                </v-list-item>
                <v-card-actions>
                <v-row>
                    <v-col>
                    <v-btn outlined text @click="openFeedback = false">
                        Cancel
                    </v-btn>
                    </v-col>
                    <v-col>
                    <v-btn class="float-right" color="green" type="submit" rounded outlined text>
                        Send Feedback
                    </v-btn>
                    </v-col>
                </v-row>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-snackbar v-if="showSnackbar"
              v-model="showSnackbar"
              :timeout="timeout"
              color="success"
          >
              {{ feedbackSnackbarMessage }}
          </v-snackbar>
        </v-col>
        <v-col cols="auto">
          <v-dialog 
            v-model="activeOrganisations"
            persistent
            transition="dialog-bottom-transition" 
            :fullscreen="isMobile"
            style="position: absolute; z-index: 1200;"
            width="420" max-height="500">
            <template v-slot:activator="{ on }">
              <v-btn outlined small v-on="on" fab class="ma-1 white-text" color="white">
                  <v-icon medium color="white" size="30">mdi-cash-marker </v-icon>
              </v-btn>
            </template>
            <v-card max-width="420" color="white" class="mx-auto bordered">
              <v-toolbar color="blue darken-4" height="90" flat>
                <template v-slot:prepend>
                  <v-btn icon="mdi-arrow-left"> </v-btn>
                </template>

                <v-text-field v-model="search" type="input" background-color="white" filled
                  placeholder="Search Active Organisations" hide-details clearable clear-icon="mdi-close-circle"class="pr-3 pt-3">
                </v-text-field>
                <v-dialog
                  v-model="openDonation"
                  max-width="500px"
                  :fullscreen="$vuetify.breakpoint.smAndDown"
                  persistent
                >
                  <template v-slot:activator="{ props, on }">
                    <v-btn color="transparent" @click="activeOrganisations=false" fab x-small outlined>
                      <v-icon color="white"">mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="transparent" fab small outlined v-bind="props" v-on="on" v-model="sheet" @click="toggleDonationForm">
                      <v-icon color="white"">mdi-plus-circle</v-icon>
                    </v-btn>
                  </template>
                    <donationForm @close-dialog="openDonation=false"/>
                </v-dialog>
                <template v-slot:append>
                  <v-btn icon="mdi-dots-vertical"></v-btn>
                </template>
              </v-toolbar>
              <div v-if="keywords.length > 0" class="py-3 px-4">
                  <v-chip color="white" v-for="(keyword, i) in keywords" :key="i" class="me-2">
                  {{ keyword }}
                  </v-chip>
              </div>
              <v-container class="pa-2">
                <v-row dense>
                  <v-col v-for="(item, i) in searching" :key="i" link>
                      <v-card>
                        <div class="d-flex flex-no-wrap justify-space-between">
                            <div>
                              <v-card-title class="text-h6" v-text="item.title"/>
                              <v-card-subtitle class="text-caption" v-text="item.description"/>
                              <v-card-actions>
                                <v-dialog
                                  v-model="showForm"
                                  transition="dialog-bottom-transition"
                                  :fullscreen="$vuetify.breakpoint.smAndDown"
                                  :overlay-opacity="0"
                                  max-width="500"
                                  persistent
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" x-small color="green darken-2" class="ml-2 white--text" outlined rounded small>
                                      Donate Now
                                    </v-btn>
                                  </template>
                                  <donationLink @close-dialog="showForm = false" />
                                </v-dialog>
                              </v-card-actions>
                            </div>
                            <v-avatar class="ma-0" size="95" tile>
                              <v-img :src="item.src"></v-img>
                            </v-avatar>
                        </div>
                      </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
          <!-- End of Dollar sign icon -->
          
          <!-- Beginning of upload box -->
          <v-dialog
            v-model="openPostDialog"
            fullscreen
            persistent
            hide-overlay
            v-if="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
            style="position: relative; z-index: 1200;"
          >
            <!-- Floating FAB Activator -->
            <template v-slot:activator="{ on }">
              <v-btn
                small
                fab
                class="ma-1 white--text"
                color="blue darken-3"
                style="position: relative; z-index: 1200;"
                v-on="on"
              >
                <v-icon>mdi-camera-plus</v-icon>
              </v-btn>
            </template>

            <!-- Fullscreen Post Mobile Composer -->
            <v-card class="rounded-0">
              <v-form v-on:submit.prevent="handleUpload()" v-model="form">
                <!-- Top Toolbar -->
                <v-toolbar flat dense color="white">
                  <v-btn text color="primary" @click="openPostDialog = false">Cancel</v-btn>

                  <v-spacer></v-spacer>

                  <!-- ✅ Live mode toggle button -->
                  <v-btn 
                    text 
                    :color="isLive ? 'red' : 'blue'" 
                    @click="isLive = !isLive"
                  >
                    {{ isLive ? 'Live Mode' : 'Go Live' }}
                    <v-icon class="pl-1">mdi-antenna</v-icon>
                  </v-btn>

                  <!-- Ping button -->
                  <v-btn 
                    type="submit" 
                    :disabled="isFormEmpty" 
                    color="success" 
                    depressed
                    @click="dialog.value = false; showProgressBar = true; handleUploadProgressBar();"
                  >
                    Ping
                  </v-btn>
                </v-toolbar>

                <!-- Composer Body -->
                <v-container fluid class="pa-2" style="position: relative; z-index: 1200;">
                  <v-row no-gutters>
                    <v-col cols="2" class="pt-2">
                      <v-avatar size="40">
                        <v-img :src="profile_image"></v-img>
                      </v-avatar>
                    </v-col>

                    <v-col v-if="!isLive" cols="10">
                      <v-textarea
                        v-model="uploadedText"
                        placeholder="Ping your thoughts to the World."
                        auto-grow
                        style="max-height: 200px; overflow-y: auto;"
                        autofocus
                        solo
                        flat
                        clearable
                        hide-details
                        rows="3"
                      ></v-textarea>
                    </v-col>
                    <v-col v-if="isLive" cols="10">
                      <v-textarea
                        v-model="uploadedLiveText"
                        placeholder="Ping your thoughts to the World."
                        auto-grow
                        style="max-height: 200px; overflow-y: auto;"
                        autofocus
                        solo
                        flat
                        clearable
                        hide-details
                        rows="3"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <!-- ✅ File Upload Section (with Video Thumbnail label in Live mode) -->
                   <v-row v-if="isLive" no-gutters align="center" class="pt-2 pb-1">
                    <v-file-input
                      v-model="uploadedThumbnail"
                      type="file"
                      hide-details
                      dense
                      solo
                      flat
                      class="flex-grow-1"
                      prepend-icon=""
                      label="Upload Video Thumbnail"
                      prepend-inner-icon="mdi-image-outline"
                    />
                  </v-row>
                  <v-row v-if="!isLive" no-gutters align="center" class="pt-2 pb-1">
                    <v-file-input
                      v-model="uploadedFiles"
                      type="file"
                      hide-details
                      dense
                      solo
                      flat
                      class="flex-grow-1"
                      prepend-icon=""
                      prepend-inner-icon="mdi-image-outline"
                    />
                  </v-row>
                  <!-- ✅ Hide link field when Live Mode is ON -->
                  <v-row v-if="!isLive" no-gutters class="px-3">
                    <v-text-field
                      v-model="uploadedLink"
                      filled
                      dense
                      hide-details
                      label="Add article link (if any)"
                    ></v-text-field>
                  </v-row>

                  <!-- Location (still required in both modes) -->
                  <v-row v-if="!isLive" no-gutters class="px-3 pt-2">
                    <v-autocomplete
                      label="Location (Required)"
                      :items="countries"
                      dense
                      return-object
                      clearable
                      item-text="name"
                      v-model="uploadLocation"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="red">mdi-map-marker-right</v-icon>
                      </template>
                    </v-autocomplete>
                  </v-row>
                  <!-- Location (still required in both modes) -->
                  <v-row v-if="isLive" no-gutters class="px-3 pt-2">
                    <v-autocomplete
                      label="Location (Required)"
                      :items="countries"
                      dense
                      clearable
                      return-object
                      item-text="name"
                      v-model="uploadLiveLocation"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="red">mdi-map-marker-right</v-icon>
                      </template>
                    </v-autocomplete>
                    <v-btn
                      v-if="isLive"
                      color="red darken-2"
                      :disabled="canStartLiveStream"
                      class="mt-4 white--text"
                      block
                      large
                      @click="startLiveStream">
                      <v-icon left>mdi-video</v-icon>
                      Start Live Stream
                    </v-btn>  
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- Desktop (non-fullscreen) version -->
          <v-dialog v-else style="position: relative; z-index: 1200;" persistent v-model="openPostDialog" max-width="500" max-height="500" class="ma-0">
            <template v-slot:activator="{ on }">
                <v-btn small v-on="on" fab class="ma-1 white--text" color="blue darken-3">
                    <v-icon>mdi-camera-plus</v-icon>
                </v-btn>
            </template>
            <template v-slot:default="dialog">
                <v-card class="rounded-0">
                  <!-- Top Toolbar -->
                  <v-form v-on:submit.prevent="handleUpload" v-model="form">
                    <v-toolbar flat dense color="white">
                      <v-btn text color="primary" @click="openPostDialog = false">Cancel</v-btn>
                      <v-spacer></v-spacer>
                      <!-- ✅ Live mode toggle button -->
                      <v-btn 
                        text 
                        :color="isLive ? 'red' : 'blue'" 
                        @click="isLive = !isLive"
                      >
                        {{ isLive ? 'Live Mode' : 'Go Live' }}
                        <v-icon class="pl-1">mdi-antenna</v-icon>
                      </v-btn>
                      <v-btn type="submit" :disabled="isFormEmpty" color="success" depressed @click="
                        dialog.value = false;
                        showProgressBar = true;
                        handleUploadProgressBar();">
                        Ping</v-btn>
                    </v-toolbar>

                    <!-- Composer Body -->
                    <v-container fluid class="pa-2" style="position: relative; z-index: 1200;">
                      <v-row no-gutters>
                        <!-- Avatar -->
                        <v-col cols="2" class="pt-2">
                          <v-avatar size="40">
                            <v-img :src="profile_image"></v-img>
                          </v-avatar>
                        </v-col>

                        <!-- Textarea -->
                        <v-col v-if="!isLive" cols="10">
                          <v-textarea
                            v-model="uploadedText"
                            placeholder="Ping your thought to the World."
                            auto-grow
                            autofocus
                            clearable
                            solo
                            flat
                            hide-details
                            style="max-height: 250px; overflow-y: auto;"
                            rows="3"
                          ></v-textarea>
                        </v-col>
                        <v-col v-if="isLive" cols="10">
                          <v-textarea
                            v-model="uploadedLiveText"
                            placeholder="Ping your thought to the World."
                            auto-grow
                            autofocus
                            clearable
                            solo
                            flat
                            hide-details
                            style="max-height: 250px; overflow-y: auto;"
                            rows="3"
                          ></v-textarea>
                        </v-col>
                      </v-row>

                      <!-- File Upload Section -->
                      <v-row v-if="!isLive" no-gutters align="center" class="px-3 pt-2 pb-1">
                        <v-file-input
                          v-model="uploadedFiles"
                          type="file"
                          hide-details
                          prepend-icon="mdi-image-outline"
                          dense
                          solo
                          flat
                          class="flex-grow-1"
                        ></v-file-input>
                      </v-row>
                      <v-row v-if="isLive" no-gutters align="center" class="pt-2 pb-1">
                        <v-file-input
                          v-model="uploadedThumbnail"
                          type="file"
                          hide-details
                          prepend-icon=""
                          prepend-inner-icon="mdi-image-outline"
                          label="Upload Video Thumbnail"
                          dense
                          solo
                          flat
                          class="flex-grow-1"
                        ></v-file-input>
                      </v-row>

                      <v-row v-if="!isLive" no-gutters class="px-3">
                        <v-text-field
                          v-model="uploadedLink"
                          filled
                          dense
                          hide-details
                          label="Add article link (if any)"
                        ></v-text-field>
                      </v-row>
                      <v-row v-if="!isLive" no-gutters class="px-3 pt-2">
                      <v-autocomplete
                        label="Location (Required)"
                        :items="countries"
                        dense
                        return-object
                        clearable
                        item-text="name"
                        v-model="uploadLocation"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="red">mdi-map-marker-right</v-icon>
                        </template>
                      </v-autocomplete>
                    </v-row>
                    <!-- Location (still required in both modes) -->
                    <v-row v-if="isLive" no-gutters class="px-3 pt-2">
                      <v-autocomplete
                        label="Location (Required)"
                        :items="countries"
                        dense
                        clearable
                        return-object
                        item-text="name"
                        v-model="uploadLiveLocation"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="red">mdi-map-marker-right</v-icon>
                        </template>
                      </v-autocomplete>
                      <v-btn
                        v-if="isLive"
                        color="red darken-2"
                        :disabled="canStartLiveStream"
                        class="mt-4 white--text"
                        block
                        large
                        @click="startLiveStream">
                        <v-icon left>mdi-video</v-icon>
                        Start Live Stream
                      </v-btn>  
                    </v-row>
                    </v-container>
                  </v-form>
                </v-card>
               <v-dialog 
                v-model="showProgressBar"
                persistent
                width="110"
                hide-overlay
                content-class="transparent-dialog"
              >
                <div class="text-center no-bg">
                  <v-progress-circular 
                    :rotate="-90" 
                    :size="80" 
                    :width="10" 
                    :value="progressBarValue"
                    color="primary"
                  >
                    <v-list-item-avatar class="mx-0">
                      <v-img :src="profile_image"></v-img>
                    </v-list-item-avatar>
                  </v-progress-circular>
                </div>
              </v-dialog>
            </template>
          </v-dialog>
          <!-- Progress Bar Dialog -->
          <!--
          This was just an extra dialog, might not need it.
          <v-dialog v-model="showProgressBar" style="opacity: 0;" persistent width="110">
            <div v-show="showProgressBar" class="text-center">
              <v-progress-circular
                :rotate="-90"
                :size="80"
                :width="10"
                :value="progressBarValue"
                color="primary"
              >
                <v-list-item-avatar class="mx-0">
                  <v-img :src="profile_image"></v-img>
                </v-list-item-avatar>
              </v-progress-circular>
            </div>
          </v-dialog>
          -->
        <!-- End of upload box -->
        <!-- End of camera dialog box -->
        </v-col>
      </v-card>
    </v-footer>
  </v-responsive>
</template>   

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
//import AuthService from '../../src/services/auth.service.js'
import { mapGetters, mapState } from 'vuex'
import countries from '../countries'
import trendingNews from './trendingNews'
import observationPost from './observationPost'
import pastLives from './pastLives'
import { apiUrl } from '../config'
import profilePage from './profilePage'
import leftMenu from './leftMenu'
import rightMenu from './rightMenu'
import donationForm from './donationForm'
import donationLink from './donationLink'

export default {
  data: () => ({
    isLive: false, // ✅ Live mode toggle
    uploadedThumbnail: "",
    uploadedLiveText: "",
    showForm: false,
    addOrganisations: false,
    activeOrganisations: false,
    openLeftDrawer: true,
    openRightDrawer: true,
    API_URL: apiUrl,
    form: "",
    arrayEvents: null,
    date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    showTrendingNews: false,
    progressBarValue: 0,
    showProgressBar: false,
    uploadedFiles: null,
    uploadedText: "",
    uploadedLink: "",
    uploadLocation: "",
    uploadLiveLocation: "",
    isDisabled: true,
    dialog: "",
    sheet: "",
    message4: "",
    countries: [],
    profile_image: '',
    profileData: [""],
    openPostDialog: false,
    //feedback message fields
    openFeedback: false,
    openDonation: false,
    feedbackMessage: "",
    error: null,
    success: null,
    username: "",
    feedbackSnackbarMessage: "Your feedback was sent successfully.",
    timeout: 5000,
    showSnackbar: false,
    isMobile: false,  // detect mobile however you like
    items: [
      {
        color: 'blue darken-3',
        src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
        title: 'Haiti Recovery Fund(Placeholder)',
        description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.',
        keyword: 'Support Mission',
      },
    ],
    // Third list - Chats
    //
    recent: [
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        title: 'Jason Oner',
      },
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
        title: 'Mike Carlson',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        title: 'Cindy Baker',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        title: 'Ali Connors',
      },
    ],
    previous: [
      {
        title: 'Travis Howard',
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
      },
    ],
    search: '',
  }),
  drawer: true,
  mini: true,
  expand: false,
  methods: {
    async submitFeedback(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        this.error = null;
        this.success = null;
        const response = await axios.post(
          `${this.API_URL}feedback/`, formData,
          { 
            headers: { 'Authorization': authToken, 
              'Content-Type': 'multipart/form-data',
            } 
          }
        );
        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          this.showSnackbar = true;
          this.openFeedback = false;
          this.$refs.form.reset();
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating feedback:', error);
        return false; // Failure
      }
    },
    //Handle Feedback upload
    async handleFeedbackUpload() {

      this.isLoading = true
      const feedbackIdeaData = {
        feedbackMessage: this.feedbackMessage,
      };

      console.log('feedback data from feedbackform', feedbackIdeaData);

      const formData = new FormData();
      formData.append('message', this.feedbackMessage);
    
      this.isLoading = false
    },
    triggerTrendingNews() {
      this.$emit('fetchTrendingNews');
    },
    //Menu functionality
    toggleleftMenu() {
      return this.openLeftDrawer = !this.openLeftDrawer
    },
    toggleRightMenu() {
      return this.openRightDrawer = !this.openRightDrawer
    },
    toggleMobileRightMenu() {
      return (this.isMobile = !this.isMobile) || (this.openRightDrawer = !this.openRightDrawer)
    },
    async getProfileData() {
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}users/current-user/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        this.profileData = response.data;
        this.profile_image = this.profileData?.profile.profile_image;
        console.log(this.profileData);

      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    togglePastLives() { },
    /*
    toggleDonationForm() { 
      return this.openDonation = !this.openDonation
    },
    */
    reserve() { },
    handleUploadProgressBar() {
      setInterval(() => {
        if (this.progressBarValue === 100) {
          this.showProgressBar = false;
          this.progressBarValue = 0;
          return;
        }
        this.progressBarValue += 20;
        //console.log(progressBarValue);
      }, 1000);
    },
    async createPost(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken);

        const response = await axios.post(`${this.API_URL}posts/`, formData, {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating business idea:', error);
        return false; // Failure
      }
    },

    //handle upload method
    async handleUpload() {
      if (this.uploadLocation && this.uploadedText || this.uploadedLink || this.uploadedFiles) {
        this.openPostDialog = false;
        const postData = {
          content: this.uploadedText,
          link: this.uploadedLink,
          location: this.uploadLocation.name,
          files: this.uploadedFiles
        }
        console.log('postdata from navbar', postData)

        const formData = new FormData();
        formData.append('content', this.uploadedText);
        formData.append('link', this.uploadedLink);
        formData.append('location', this.uploadLocation.name);
        if (this.uploadedFiles !== null) {
          formData.append('files', this.uploadedFiles);

        }
        
        const isSuccess = await this.createPost(formData)
        
        if (isSuccess) {

          this.$emit('fetch-posts')
        }
        
        // this.$store.dispatch('auth/post', formData).then(() => {
          //   // ... handle any further logic or UI updates
          //   this.$success('Post added successfully!');
          // }).catch(error => {
            //   // ... handle error condition
            //   console.log(error)
            //   this.$error(error)
            // });
          }
      // Clear fields after submit
      this.uploadedFiles = []
      this.uploadedText = ''
      this.uploadedLink = ''
      this.uploadLocation = null
      this.form = false  // if you’re using v-model="form" for validation
    },
    handleUploadLocation(country) {
      this.uploadLocation = country;
    },
    getCountry(country) {
      this.$emit('country', country)
    },
    toggleTrendingNews() {
      this.showTrendingNews = !this.showTrendingNews;
    },
    ...mapMutations({
      setDialog: 'setDialog'
    }),
    showChat() {
      this.setDialog(true)
    },
  },
  watch: {
    isMobile(val) {
      // reset drawer state depending on device type
      this.drawer = val; // open if desktop, closed if mobile
    },
  },
  created() {
    this.getProfileData();
  },
  mounted() {
    this.countries = countries
    this.arrayEvents = [...Array(6)].map(() => {
      const day = Math.floor(Math.random() * 30)
      const d = new Date()
      d.setDate(day)
      return d.toISOString().substr(0, 10)
    })
  },
  components: {
    trendingNews,
    pastLives,
    profilePage,
    leftMenu,
    rightMenu,
    observationPost,
    donationForm,
    donationLink
  },
  watch: {
    message(logMessage) {
      console.log('Name:', logMessage)
    },
    location(logMessage) {
      console.log('Locaion:', logMessage)
    },
    link(logMessage) {
      console.log('Link:', logMessage)
    },
    isLive() {
     this.uploadLiveLocation = '';
     this.uploadedThumbnail = null;
     this.uploadedLiveText = '';
    },
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 600;
        case 'sm': return 600;
        case 'md': return 69;
        case 'lg': return 69;
        case 'xl': return 69;
        default: return 190;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState(['user']),
    ...mapGetters({ user: "auth/user" }, { token: "auth/user" }),
    keywords() {
      if (!this.search) return []
      
      const keywords = []

      for (const search of this.searching) {
        keywords.push(search.keyword)
      }

      return keywords
    },
    searching() {
      if (!this.search) return this.items

      const search = this.search.toLowerCase()

      return this.items.filter(item => {
        const text = item.title.toLowerCase()

        return text.indexOf(search) > -1
      })
    },
    isFormEmpty() {
      return (
        (!this.uploadedText || this.uploadedText.trim() === '') &&
        (!this.uploadedLink || this.uploadedLink.trim() === '') &&
        (!this.uploadedFiles || this.uploadedFiles.length === 0) ||
        !this.uploadLocation
      );
    },
    canStartLiveStream() {
      const hasLocation =
        !this.uploadLiveLocation && this.uploadLiveLocation.trim() === '';

      const hasText =
        !this.uploadedLiveText && this.uploadedLiveText.trim() === '';

      const hasFiles =
        this.uploadedThumbnail && this.uploadedThumbnail.length !== null;

      // ✅ location REQUIRED
      // ✅ at least text OR files required
      return hasLocation && (hasText || hasFiles);
    },
  },
  props: {
    trendingNews: Array,
    value: { type: Boolean, default: false }, // <- parent will drive this
    isMobile: Boolean
  }
}
</script>

<style>
.transparent-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

.no-bg {
  background: transparent !important;
}
</style>